export default {
  model () {
    return {
      clientName: null,
      clientEmail: null,
      clientPhone: null
    }
  },
  rules (model) {
    return {
      clientName: [
        {required: true, message: 'El nombre del cliente es requerido', trigger: 'change'},
        {min: 5, message: 'El nombre debe contener al menos 5 caracteres', trigger: 'change'}
      ],
      clientPhone: [
        {required: true, message: 'El celular es requerido', trigger: 'blur'},
        {min: 10, message: 'El teléfono debe contener 10 dígitos', trigger: 'blur'},
        {
          validator: (rule, value, callback) => {
            let reg = /^\d+$/
            if (reg.test(value)) {
              callback()
            } else {
              callback(new Error('El teléfono solo debe contener dígitos'))
            }
          },
          trigger: 'change'
        }
      ],
      clientEmail: [
        {type: 'email', message: 'El email no tiene el formato correcto', trigger: 'blur'},
        {required: true, message: 'El correo electrónico es requerido', trigger: 'change'}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/client.model.js